import axios from 'axios';
import queryString from 'query-string';
import * as Sentry from 'utils/errorTracking';

import { getCategoriesUrl, getOfferingsUrl } from './api';
import { getAPI } from 'utils/helpers';

const offeringUrl = () => {
  return `${getAPI()}${getOfferingsUrl}`;
};

// handles request from server only to PF v2 offering search
export const getOfferingsServer = ({
  page,
  query,
  size,
  categoryLabel,
  sortBy,
  status,
  staticOfferings,
}) =>
  axios
    .get(
      queryString.stringifyUrl(
        {
          url: offeringUrl({
            staticOfferings,
          }),
          query: {
            page,
            query,
            size,
            categoryLabel,
            sortBy,
            status,
          },
        },
        {
          skipEmptyString: true,
        },
      ),
    )
    .then(({ data }) => data);

export const getOfferings = ({ page, query, size, categoryLabel, sortBy, status, amountFloor }) =>
  axios
    .get(
      queryString.stringifyUrl(
        {
          url: offeringUrl(),
          query: {
            page,
            query,
            size,
            categoryLabel,
            sortBy,
            status,
            amountFloor,
          },
        },
        {
          skipEmptyString: true,
        },
      ),
    )
    .then(({ data }) => data);

export const getCurrentOfferingsTombstones = ({ fingerprint }) => {
  const params = {};
  if (fingerprint) {
    params.fingerprint = fingerprint;
  }

  // Use getAPI() without useGateway flag to route through /service proxy on client-side
  // This prevents CORS issues when called from the browser
  return axios
    .get(`${getAPI()}/primary_facade/v2/offerings/current/tombstones`, {
      params,
    })
    .then(({ data }) => data);
};

export const getCurrentOfferings = async (fingerprint) => {
  try {
    const { data } = await axios.get(`${getAPI()}/primary_facade/v2/offerings/current`, {
      params: {
        fingerprint,
      },
    });
    return data;
  } catch (error) {
    Sentry.captureException(error, { tags: { service: 'explore' } });
    return {};
  }
};

export const getCategories = ({ excludedCategories }) =>
  axios
    .get(
      queryString.stringifyUrl({
        url: `${getAPI()}${getCategoriesUrl}`,
        query: {
          excludedCategories,
        },
      }),
    )
    .then(({ data }) => data);

export const getOfferingsInfinite = ({
  pageParam = 0,
  queryInfinite,
  categoryLabel,
  size,
  sortBy,
  amountFloor,
  status,
}) => {
  return axios
    .get(
      queryString.stringifyUrl(
        {
          url: offeringUrl(),
          query: {
            page: pageParam,
            query: queryInfinite,
            size,
            industries: categoryLabel,
            sortBy,
            amountFloor: amountFloor || '',
            status: status || '',
          },
        },
        {
          skipEmptyString: true,
        },
      ),
    )
    .then(({ data }) => data);
};

export const getFollowing = ({ primaryUserId, cookie }) =>
  axios
    .get(
      queryString.stringifyUrl(
        {
          url: `${getAPI()}/primary_facade/v2/users/${primaryUserId}/following`,
          page: 0,
          size: 100,
        },
        {
          skipEmptyString: true,
        },
      ),
      {
        headers: cookie
          ? {
              cookie,
            }
          : {},
        withCredentials: !!cookie,
      },
    )
    .then(({ data }) => data);

export const getSmartHomepageBanner = ({ fingerprint }) => {
  const params = {};
  if (fingerprint) {
    params.fingerprint = fingerprint;
  }

  return axios
    .get(`${getAPI()}/primary_facade/v2/offerings/matchedOfferingsBanner`, {
      params: {
        fingerprint,
      },
    })
    .then(({ data }) => data);
};
